import Typography from "ds/components/Typography";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

import styles from "./styles.module.css";

type AiIntegrationDeleteConfirmationContentProps = {
  integration: AiIntegrationView;
};

const AiIntegrationDeleteConfirmationContent = (
  props: AiIntegrationDeleteConfirmationContentProps
) => {
  const { integration } = props;

  return (
    <div>
      <Typography className={styles.text} tag="p">
        Are you sure you want to delete the integration:
      </Typography>
      <div className={styles.details}>
        <Typography className={styles.detailsLabel} tag="p">
          Name
        </Typography>
        <Typography tag="p">{integration.name}</Typography>
        <Typography className={styles.detailsLabel} tag="p">
          Type
        </Typography>
        <Typography tag="p">AI</Typography>
        <Typography className={styles.detailsLabel} tag="p">
          Provider
        </Typography>
        <Typography tag="p">{integration.provider}</Typography>
        <Typography className={styles.detailsLabel} tag="p">
          Models
        </Typography>
        <Typography tag="p">
          {integration.modelDetails.map((model) => model.name).join(", ")}
        </Typography>
      </div>
    </div>
  );
};

export default AiIntegrationDeleteConfirmationContent;
